export enum TKey {
  USERS = "USERS",
  ADD_USER = "ADD_USER",
  EDIT_USER = "EDIT_USER",
  DELETE_USER = "DELETE_USER",
  CONFIRM_TITLE = "CONFIRM_TITLE",
  CONFIRM_DELETE_PATIENT = "CONFIRM_DELETE_PATIENT",
  CONFIRM_DELETE_USER = "CONFIRM_DELETE_USER",
  CONFIRM_DELETE_INSOLE_MODEL = "CONFIRM_DELETE_INSOLE_MODEL",
  INSOLE_PAIRS_EMPTY = "INSOLE_PAIRS_EMPTY",
  CHOOSE_INSOLE_MODEL = "CHOOSE_INSOLE_MODEL",
  NO_INSOLE_MODEL_AVAILABLE = "NO_INSOLE_MODEL_AVAILABLE",
  PATIENT_DETAILS = "PATIENT_DETAILS",
  BACK_TO_PATIENTS = "BACK_TO_PATIENTS",
  BACK_TO_LIBRARY = "BACK_TO_LIBRARY",
  INSOLES = "INSOLES",
  ADD_INSOLE_PAIR = "ADD_INSOLE_PAIR",
  INSOLE_PAIR_NAME = "INSOLE_PAIR_NAME",
  INSOLE_PAIR_NOTES = "INSOLE_PAIR_NOTES",
  EDIT_INSOLE_PAIR = "EDIT_INSOLE_PAIR",
  DELETE_INSOLE_PAIR = "DELETE_INSOLE_PAIR",
  CONFIRM_DELETE_INSOLE_PAIR = "CONFIRM_DELETE_INSOLE_PAIR",
  OPEN_CONFIGURATOR = "OPEN_CONFIGURATOR",
  CONFIGURE = "CONFIGURE",
  CREATED_ON = "CREATED_ON",
  UPDATED_ON = "UPDATED_ON",
  MEASURE = "MEASURE",
  INVERT_SIDE = "INVERT_SIDE",
  MEASURE_TOOLS = "MEASURE_TOOLS",
  MEASURE_HINT = "MEASURE_HINT",
  MEASURE_POINT_TO_POINT = "MEASURE_POINT_TO_POINT",
  MEASURE_POINT_TO_GROUND = "MEASURE_POINT_TO_GROUND",
  MEASURE_EMPTY = "MEASURE_EMPTY",
  MEASURE_KEEP_VISIBLE = "MEASURE_KEEP_VISIBLE",
  RESET = "RESET",
  EXPORT = "EXPORT",
  EXPORT_BOTH = "EXPORT_BOTH",
  EXPORT_IN_PROGRESS = "EXPORT_IN_PROGRESS",
  EXPORT_NOT_WATERTIGHT_TITLE = "EXPORT_NOT_WATERTIGHT_TITLE",
  EXPORT_NOT_WATERTIGHT_MESSAGE = "EXPORT_NOT_WATERTIGHT_MESSAGE",
  FOOT_LEFT = "FOOT_LEFT",
  FOOT_RIGHT = "FOOT_RIGHT",
  VIEW_TOP = "VIEW_TOP",
  VIEW_BOTTOM = "VIEW_BOTTOM",
  VIEW_LEFT = "VIEW_LEFT",
  VIEW_RIGHT = "VIEW_RIGHT",
  VIEW_FRONT = "VIEW_FRONT",
  VIEW_BACK = "VIEW_BACK",
  ZONE_TOP = "ZONE_TOP",
  ZONE_BASE = "ZONE_BASE",
  VARUS_VALGUS = "VARUS_VALGUS",
  TALONNETTE = "TALONNETTE",
  ZONE_FRONT_HEIGHT = "ZONE_FRONT_HEIGHT",
  ZONE_BACK_HEIGHT = "ZONE_BACK_HEIGHT",
  TILT_FRONT_BACK = "TILT_FRONT_BACK",
  TILT_MEDIO_LATERAL = "TILT_MEDIO_LATERAL",
  CORRECTION = "CORRECTION",
  DIMENSIONS = "DIMENSIONS",
  POSITION = "POSITION",
  ROTATION = "ROTATION",
  CONFIRM_RESET_CONFIGURATOR = "CONFIRM_RESET_CONFIGURATOR",
  ADD_ZONE = "ADD_ZONE",
  ZONE_NAME = "ZONE_NAME",
  ZONES = "ZONES",
  ZONE_PRESETS = "ZONE_PRESETS",
  ZONE_CUSTOM = "ZONE_CUSTOM",
  ZONE_PRESETS_EMPTY = "ZONE_PRESETS_EMPTY",
  ZONE_PRESETS_GLOBAL = "ZONE_PRESETS_GLOBAL",
  ZONE_PRESETS_MINE = "ZONE_PRESETS_MINE",
  SAVE_AS_PRESET = "SAVE_AS_PRESET",
  DELETE_ZONE_PRESET = "DELETE_ZONE_PRESET",
  ZONE_SHAPE = "ZONE_SHAPE",
  ZONE_PROFILE = "ZONE_PROFILE",
  ZONE_KIND_BUMP = "ZONE_KIND_BUMP",
  ZONE_KIND_CUP = "ZONE_KIND_CUP",
  ZONE_KIND_WEDGE = "ZONE_KIND_WEDGE",
  ZONE_ANGLE = "ZONE_ANGLE",
  ZONE_AREA = "ZONE_AREA",
  DELETE_ZONE = "DELETE_ZONE",
  DIMENSION_WIDTH = "DIMENSION_WIDTH",
  DIMENSION_LENGTH = "DIMENSION_LENGTH",
  DIMENSION_HEIGHT = "DIMENSION_HEIGHT",
  ADMIN_VIEW = "ADMIN_VIEW",
  PRO_VIEW = "PRO_VIEW",
  PRACTICE_NOT_CONFIGURED = "PRACTICE_NOT_CONFIGURED",
  ADD_AS_PRACTITIONER = "ADD_AS_PRACTITIONER",
  PRACTICE_NAME = "PRACTICE_NAME",
  PRACTICE_ADDRESS = "PRACTICE_ADDRESS",
  PRACTICE_CITY = "PRACTICE_CITY",
  PRACTICE_POSTAL_CODE = "PRACTICE_POSTAL_CODE",
  PRACTICE_COUNTRY = "PRACTICE_COUNTRY",
  USER_PENDING = "USER_PENDING",
  INVITE_USER_SENT = "INVITE_USER_SENT",
  USER_ADDED = "USER_ADDED",
  USER_ACTIVE = "USER_ACTIVE",
  USER_NO_INVITE_SENT = "USER_NO_INVITE_SENT",
  SEND_INVITATION = "SEND_INVITATION",
  RESEND_INVITATION = "RESEND_INVITATION",
  INVITE_OR_SKIP = "INVITE_OR_SKIP",
  SKIP = "SKIP",
  USER_EMAIL_PENDING = "USER_EMAIL_PENDING",
  EMAIL_CONFIRM_EMAIL_TITLE = "EMAIL_CONFIRM_EMAIL_TITLE",
  EMAIL_CONFIRM_EMAIL_TEXT = "EMAIL_CONFIRM_EMAIL_TEXT",
  EMAIL_CONFIRM_EMAIL_ACTION = "EMAIL_CONFIRM_EMAIL_ACTION",
  CONFIRM_EMAIL_LOADING = "CONFIRM_EMAIL_LOADING",
  CONFIRM_EMAIL_SUCCESS = "CONFIRM_EMAIL_SUCCESS",
  CONFIRM_EMAIL_ERROR = "CONFIRM_EMAIL_ERROR",
  USERS_EMPTY = "USERS_EMPTY",
  DR = "DR",
  OPTIONAL = "OPTIONAL",
  APP_TITLE = "APP_TITLE",
  APP_DESCRIPTION = "APP_DESCRIPTION",
  APP_KEYWORDS = "APP_KEYWORDS",
  EDIT = "EDIT",
  CANCEL = "CANCEL",
  SAVE = "SAVE",
  DELETE = "DELETE",
  SETTINGS = "SETTINGS",
  SIGN_OUT = "SIGN_OUT",
  GENERAL = "GENERAL",
  OVERVIEW = "OVERVIEW",
  OVERVIEW_TOTAL = "OVERVIEW_TOTAL",
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  PHONE = "PHONE",
  NOT_FOUND_TITLE = "NOT_FOUND_TITLE",
  NOT_FOUND_TEXT = "NOT_FOUND_TEXT",
  NOT_FOUND_ACTION = "NOT_FOUND_ACTION",
  MANAGE = "MANAGE",
  EMAIL_HELLO = "EMAIL_HELLO",
  EMAIL_RESET_PASSWORD_TITLE = "EMAIL_RESET_PASSWORD_TITLE",
  EMAIL_RESET_PASSWORD_TEXT = "EMAIL_RESET_PASSWORD_TEXT",
  EMAIL_RESET_MY_PASSWORD_ACTION = "EMAIL_RESET_MY_PASSWORD_ACTION",
  EMAIL_IGNORE_REQUEST = "EMAIL_IGNORE_REQUEST",
  EMAIL_BEST_REGARDS = "EMAIL_BEST_REGARDS",
  EMAIL_TEAM = "EMAIL_TEAM",
  EMAIL_INVITE_TITLE = "EMAIL_INVITE_TITLE",
  EMAIL_INVITE_TEXT = "EMAIL_INVITE_TEXT",
  EMAIL_INVITE_ACTION = "EMAIL_INVITE_ACTION",
  ERROR = "ERROR",
  ERROR_REQUIRED = "ERROR_REQUIRED",
  ERROR_REQUIRED_SELECTION = "ERROR_REQUIRED_SELECTION",
  ERROR_INVALID_EMAIL = "ERROR_INVALID_EMAIL",
  ERROR_INVALID_PHONE = "ERROR_INVALID_PHONE",
  ERROR_INVALID_IMAGE = "ERROR_INVALID_IMAGE",
  ERROR_TOO_LONG_VALUE = "ERROR_TOO_LONG_VALUE",
  ERROR_INVALID_LINK = "ERROR_INVALID_LINK",
  ERROR_RECAPTCHA_INVALID = "ERROR_RECAPTCHA_INVALID",
  ERROR_ALREADY_SUBMITTED_PROJECT = "ERROR_ALREADY_SUBMITTED_PROJECT",
  ERROR_USER_EMAIL_NOT_FOUND = "ERROR_USER_EMAIL_NOT_FOUND",
  ERROR_INVALID_EMAIL_OR_PASSWORD = "ERROR_INVALID_EMAIL_OR_PASSWORD",
  ERROR_SHORT_PASSWORD = "ERROR_SHORT_PASSWORD",
  ERROR_EQUAL_REPEAT_PASSWORD = "ERROR_EQUAL_REPEAT_PASSWORD",
  ERROR_EMAIL_ALREADY_EXISTS = "ERROR_EMAIL_ALREADY_EXISTS",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  FORGOT_PASSWORD_TITLE = "FORGOT_PASSWORD_TITLE",
  FORGOT_PASSWORD_ACTION = "FORGOT_PASSWORD_ACTION",
  RESET_PASSWORD_TITLE = "RESET_PASSWORD_TITLE",
  RESET_PASSWORD_EMAIL_SENT = "RESET_PASSWORD_EMAIL_SENT",
  BACK_TO_LOGIN = "BACK_TO_LOGIN",
  LOG_IN_LABEL = "LOG_IN_LABEL",
  LOG_IN_TITLE = "LOG_IN_TITLE",
  LOG_IN_FIRST_TITLE = "LOG_IN_FIRST_TITLE",
  LOG_IN_ACTION = "LOG_IN_ACTION",
  LOG_IN_REMEMBER_ME = "LOG_IN_REMEMBER_ME",
  LOG_IN_FORGOT_PASSWORD = "LOG_IN_FORGOT_PASSWORD",
  LOG_IN_NO_ACCOUNT = "LOG_IN_NO_ACCOUNT",
  LOG_IN_REQUEST_DEMO = "LOG_IN_REQUEST_DEMO",
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD",
  REPEAT_PASSWORD = "REPEAT_PASSWORD",
  NEW_PASSWORD = "NEW_PASSWORD",
  PATIENTS = "PATIENTS",
  ADD_PATIENT = "ADD_PATIENT",
  LIBRARY = "LIBRARY",
  INSOLE_MODELS = "INSOLE_MODELS",
  ADD_INSOLE_MODEL = "ADD_INSOLE_MODEL",
  PROFESSION_ORTHOPEDISTE_ORTHESISTE = "PROFESSION_ORTHOPEDISTE_ORTHESISTE",
  PROFESSION_PODO_ORTHESISTE = "PROFESSION_PODO_ORTHESISTE",
  PROFESSION_ORTHOPROTHESISTE = "PROFESSION_ORTHOPROTHESISTE",
  EDIT_PATIENT = "EDIT_PATIENT",
  PATIENT_ADDED = "PATIENT_ADDED",
  PATIENT_DELETED = "PATIENT_DELETED",
  DELETE_PATIENT = "DELETE_PATIENT",
  PATIENT_BIRTH_DATE = "PATIENT_BIRTH_DATE",
  PATIENT_SIZE_EU = "PATIENT_SIZE_EU",
  PATIENT_SIZE_MM = "PATIENT_SIZE_MM",
  PATIENT_WEIGHT = "PATIENT_WEIGHT",
  PATIENT_NOTES = "PATIENT_NOTES",
  PATIENT_MEASUREMENTS = "PATIENT_MEASUREMENTS",
  PATIENT_NO_DATA = "PATIENT_NO_DATA",
  PATIENTS_RECENT = "PATIENTS_RECENT",
  PATIENTS_EMPTY = "PATIENTS_EMPTY",
  SETTINGS_ACCOUNT = "SETTINGS_ACCOUNT",
  SETTINGS_RESET_PASSWORD = "SETTINGS_RESET_PASSWORD",
  SETTINGS_RESET_PASSWORD_SENT = "SETTINGS_RESET_PASSWORD_SENT",
  SETTINGS_PRACTITIONER = "SETTINGS_PRACTITIONER",
  SETTINGS_PROFESSION = "SETTINGS_PROFESSION",
  SETTINGS_PROFESSION_OTHER_LABEL = "SETTINGS_PROFESSION_OTHER_LABEL",
  SETTINGS_PROFESSION_OTHER_PLACEHOLDER = "SETTINGS_PROFESSION_OTHER_PLACEHOLDER",
  SETTINGS_PROFESSIONAL_ID_TYPE = "SETTINGS_PROFESSIONAL_ID_TYPE",
  SETTINGS_PROFESSIONAL_ID_NUMBER = "SETTINGS_PROFESSIONAL_ID_NUMBER",
  PROFESSION_PEDICURE_PODOLOGUE = "PROFESSION_PEDICURE_PODOLOGUE",
  SETTINGS_PRACTICE = "SETTINGS_PRACTICE",
  SETTINGS_NO_PRACTICE = "SETTINGS_NO_PRACTICE",
  SETTINGS_EMAIL_READONLY_TOOLTIP = "SETTINGS_EMAIL_READONLY_TOOLTIP",
  SETTINGS_PRACTICE_READONLY = "SETTINGS_PRACTICE_READONLY",
  PATIENT_NO_PRACTITIONER_TITLE = "PATIENT_NO_PRACTITIONER_TITLE",
  PATIENT_NO_PRACTITIONER_TEXT = "PATIENT_NO_PRACTITIONER_TEXT",
  PATIENT_NO_PRACTITIONER_ACTION = "PATIENT_NO_PRACTITIONER_ACTION",
  INSOLE_MODELS_EMPTY = "INSOLE_MODELS_EMPTY",
  INSOLE_MODEL_SIDE_LEFT = "INSOLE_MODEL_SIDE_LEFT",
  INSOLE_MODEL_SIDE_RIGHT = "INSOLE_MODEL_SIDE_RIGHT",
  INSOLE_MODEL_PUBLIC = "INSOLE_MODEL_PUBLIC",
  INSOLE_MODEL_PERSONAL = "INSOLE_MODEL_PERSONAL",
  INSOLE_MODEL_NAME = "INSOLE_MODEL_NAME",
  INSOLE_MODEL_SIDE = "INSOLE_MODEL_SIDE",
  INSOLE_MODEL_VISIBILITY = "INSOLE_MODEL_VISIBILITY",
  INSOLE_MODEL_FILE = "INSOLE_MODEL_FILE",
  INSOLE_MODEL_FILE_HINT = "INSOLE_MODEL_FILE_HINT",
  INSOLE_MODEL_FILE_SELECT = "INSOLE_MODEL_FILE_SELECT",
  INSOLE_MODEL_FILE_REPLACE = "INSOLE_MODEL_FILE_REPLACE",
  INSOLE_MODEL_PREVIEW = "INSOLE_MODEL_PREVIEW",
  INSOLE_MODEL_PREVIEW_HINT = "INSOLE_MODEL_PREVIEW_HINT",
  INSOLE_MODEL_PREVIEW_SELECT = "INSOLE_MODEL_PREVIEW_SELECT",
  EDIT_INSOLE_MODEL = "EDIT_INSOLE_MODEL",
  DELETE_INSOLE_MODEL = "DELETE_INSOLE_MODEL",
  ERROR_INVALID_FILE = "ERROR_INVALID_FILE",
  ERROR_INSOLE_MODEL_IN_USE = "ERROR_INSOLE_MODEL_IN_USE",
  ERROR_ZONE_PRESET_NAME_TAKEN = "ERROR_ZONE_PRESET_NAME_TAKEN",
  PATIENT_GENDER = "PATIENT_GENDER",
  PATIENT_GENDER_MALE = "PATIENT_GENDER_MALE",
  PATIENT_GENDER_FEMALE = "PATIENT_GENDER_FEMALE",
  PATIENT_GENDER_OTHER = "PATIENT_GENDER_OTHER",
}
